import { Capacitor } from '@capacitor/core';

/** Capacitor ネイティブシェル内で動作しているか */
export const isNativeApp = () => Capacitor.isNativePlatform();

/** OAuth 開始時にバックエンドへ渡すクライアント種別 */
export const getOAuthClient = () => (isNativeApp() ? 'mobile' : 'web');
